export const currencyFormatter = (price) => {
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(price);
}

/**
 * Memformat angka menjadi notasi ringkas (k, m, b, t).
 * Contoh: 10000 -> "10k", 1500 -> "1.5k", 1000000 -> "1m"
 * @param {number} price Angka yang akan diformat.
 * @returns {string} String yang telah diformat.
 */
export const compactNumberFormatter = (price) => {
  // 1. Gunakan locale 'en' (English) agar mendapatkan simbol
  //    'k' (kilo) dan 'm' (million), BUKAN 'rb' (ribu) dan 'jt' (juta) dari 'id-ID'.
  //
  // 2. Gunakan notation: 'compact' untuk mengaktifkan format ini.
  //
  // 3. Gunakan maximumSignificantDigits: 3 agar:
  //    - 1500 -> "1.5k" (2 digit)
  //    - 1580 -> "1.58k" (3 digit)
  //    - 10000 -> "10k" (2 digit)
  
  const formatter = new Intl.NumberFormat("en", {
    notation: "compact",
    maximumSignificantDigits: 3
  });

  // Intl.NumberFormat menghasilkan 'K' (huruf besar).
  // Kita ubah ke 'k' (huruf kecil) sesuai permintaan.
  return formatter.format(price).toLowerCase();
}